import { render, staticRenderFns } from "./ShopifyIntegrationConfig.vue?vue&type=template&id=09ccd1ef&scoped=true&lang=pug"
import script from "./ShopifyIntegrationConfig.vue?vue&type=script&lang=js"
export * from "./ShopifyIntegrationConfig.vue?vue&type=script&lang=js"
import style0 from "./ShopifyIntegrationConfig.vue?vue&type=style&index=0&id=09ccd1ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ccd1ef",
  null
  
)

export default component.exports